import React from 'react';
import SEO from '../../common/SEO';
import HeaderTwo from '../../common/header/HeaderTwo';
import FooterOne from '../../common/footer/FooterOne';
import Banner from '../../components/solutions/maritime/Banner';
import AISolutions from '../../components/solutions/maritime/AISolutions';
import CaseStudy from '../../components/solutions/maritime/CaseStudy';
import MaritimeTransformation from '../../components/solutions/maritime/MaritimeTransformation';
import Advantage from '../../components/solutions/maritime/Advantage';
import FooterBanner from '../../components/solutions/maritime/FooterBanner';

const Maritime = () => {

  return (
    <>
      <SEO
				title="Maritime Industry Solutions"
				description="Powering Smart, Sustainable Maritime Operations with Edge AI"
      />
      <HeaderTwo styles="header-transparent header-style-2" searchDisable />
      <Banner />
      <AISolutions />
      <CaseStudy />
      <MaritimeTransformation />
      <Advantage />
      <FooterBanner />
      <FooterOne />
    </>
  )
}

export default Maritime;